<template lang="pug">
  .d-case
    img.top-img(src="~assets/case/08/img1.jpg")
    .content
      .case-num Vol.08
      .case-title 不请设计师，魔都小两口玩转91㎡两房，软装配色美出天际
      img.cont-img(src="~assets/case/08/img2.jpg")
      .line1 Siney夫妇是典型的90后，崇尚自我，喜欢时尚潮流。他们对生活审美的追求，就表达在这套新房里。
      img.cont-img(src="~assets/case/08/img3.jpg")
      .line1 两人经历了长达9年的爱情长跑，去年领证结婚，今年年初搬进新居，感情生活水到渠成。生活里的一切，都呈现着不多不少、刚刚好的状态。
      img.cont-img(src="~assets/case/08/img4.jpg")
      .line1 装修没有请设计师，而是由夫妻俩亲自设计。空间功能、多个细节，都按照两人的喜好来定，打造出属于自己的完美新居。
      img.cont-img(src="~assets/case/08/img5.jpg")
      .line2 Siney的先生对空间布局颇有研究，根据两人的生活习惯，<br/> 对原始户型做了不少的调整。
      .line1 挪动餐厅墙面，增加活动空间<br/>储物间改成衣帽间，更适合时尚达人<br/> 卫生间干湿分离，可同时使用、互不干扰<br/>次卧当工作室，满足在家办公需求
      img.cont-img(src="~assets/case/08/img6.jpg")
      .line1 改造后的客餐厅，有强烈的通透感，这里是家里主要的活动区域。
      img.cont-img(src="~assets/case/08/img7.jpg")
      .line1 两人喜欢玩switch，需要大一点的活动空间，所以客厅搭配不复杂，保留空间的宽敞度。
      img.cont-img(src="~assets/case/08/img8.jpg")
      .line1 Siney从小学芭蕾，有良好的艺术熏陶，加上老公对装修的研究，两人在软装上都有很不错的审美水平。家里的大件小件，都由两人亲自挑选搭配。
      img.cont-img(src="~assets/case/08/img9.jpg")
      .line1 转角沙发宽大舒适，贵妃位坐卧皆宜。阳台采光充足，视野开阔，坐在这里感觉很棒。<br/> 这段时间因为疫情，Siney经常在家办公，所以除了次卧外，这里也成了她临时的“办公区”。
      img.cont-img(src="~assets/case/08/img10.jpg")
      .line1 客厅沙发区的挂画、抱枕和吕格地毯经过了精心搭配，三者从色彩到图案，都相互呼应
      img.cont-img(src="~assets/case/08/img11.jpg")
      .line1 窗帘则与沙发同为灰色，形成呼应。
      img.cont-img(src="~assets/case/08/img12.jpg")
      .line1 客厅区还配了一张达拉斯懒人沙发，可以随时挪动。
      .line1 妈妈隔三差五过来玩，喜欢把懒人沙发放在阳台上，坐着晒太阳，享受慵懒时光。
      img.cont-img(src="~assets/case/08/img13.jpg")
      .line1 Siney对自己挑的这套詹森茶几赞不绝口，颜值高、又实用，小个茶几还能放角落当边几。朋友来家里玩，都问她在哪买的。
      img.cont-img(src="~assets/case/08/img14.jpg")
      .line1 客厅的收纳柜不多，精选了两款，是同一系列。
      .line1 游戏卡、电子产品等物品，都放在埃尔坎电视柜里，保持客厅的干净整洁。
      img.cont-img(src="~assets/case/08/img15.jpg")
      .line1 生活用品、化妆品之类，则放在靠近卫生间的埃尔坎五斗柜里，方便拿取和使用。
      img.cont-img(src="~assets/case/08/img16.jpg")
      .line1 可以看到，在选择家具、家居时，两人还很注意细节。柜子、拉森大理石挂钟等物件上，都采用了黄铜材质，打造轻奢的质感。
      img.cont-img(src="~assets/case/08/img17.jpg")
      .line1 挪动了餐厅和卫生间之间的墙壁，餐厅变大了，卫生间空间也依然足够。家人朋友来家里玩，有了更宽阔的活动区域。
      img.cont-img(src="~assets/case/08/img18.jpg")
      .line1 全黑色实木的蒙塔娜餐桌，面积宽大，平时两人在家吃饭很宽敞，家人朋友偶尔来玩，也很够用。
      .line1 搭配四张黑色的罗谢尔温莎餐椅，再配上Siney挑选的坐垫和椅腿套，餐厅的氛围既高级又有趣。
      img.cont-img(src="~assets/case/08/img19.jpg")
      .line1 餐桌上的欧文台灯，黄铜材质与家具吻合。靠墙摆放的艾伯特装饰画，让餐厅有了艺术的气息。
      img.cont-img(src="~assets/case/08/img20.jpg")
      .line1 花瓶也是很好的装饰品，一套哈里斯花瓶高低错落，带来层叠有致的美妙景致。
      img.cont-img(src="~assets/case/08/img21.jpg")
      .line1 搭配的一张希科地毯，厚实柔软，条纹图案，让餐厅空间的温馨感更加饱满。
      img.cont-img(src="~assets/case/08/img22.jpg")
      .line1 整墙餐边柜是定制的，收纳能力充足，兼具展示功能。
      img.cont-img(src="~assets/case/08/img23.jpg")
      .line1 架子上摆放着Siney最爱的pop mart玩偶，这整盒的玩偶都是抽盲盒得来的，花了好一番功夫呢！
      img.cont-img(src="~assets/case/08/img24.jpg")
      .line1 与餐桌相对的是入户处，安装了全身镜和挂钩，简洁实用。
      img.cont-img(src="~assets/case/08/img25.jpg")
      img.cont-img(src="~assets/case/08/img26.jpg")
      .line1 紧挨大门处，本来有一个储物间，Siney家把储物间的开口调整到了主卧内，并把它改成了步入式衣帽间。
      img.cont-img(src="~assets/case/08/img27.jpg")
      .line1 衣帽间收纳能力超强，同时也是更衣室，符合时尚爱美的年轻人的需求。
      img.cont-img(src="~assets/case/08/img28.jpg")
      .line1 主卧墙面是时下流行的单面刷色，湖蓝色气质恬静。<br/> 灰色的娜塔莎丝绒双人床，轻奢时尚，适合主卧的风格和Siney家的时尚感。
      img.cont-img(src="~assets/case/08/img29.jpg")
      .line1 衣帽间收纳力已经足够，床头就只搭配一个海拉床头柜，放手机、纸巾等小物件。
      img.cont-img(src="~assets/case/08/img30.jpg")
      .line1 另一边是一张梳妆台，放一些化妆品、首饰等物件，Siney有时候也会在这梳妆打扮。
      img.cont-img(src="~assets/case/08/img31.jpg")
      .line1 黄铜单椅搭一张桑德罗羊皮毯，色系跟床头的哈特维尔台灯相匹配，小角落也透露着生活的精致感
      img.cont-img(src="~assets/case/08/img32.jpg")
      .line1 飘窗上放满了各式各样的娃娃，流露出90后女生可爱的一面。
      img.cont-img(src="~assets/case/08/img33.jpg")
      .line1 几个主要活动空间的灯饰都经过精心挑选，圆润的白色玻璃灯罩，配合黄铜质感，让家里的灯光效果和谐统一。
      img.cont-img(src="~assets/case/08/img34.jpg")
      img.cont-img(src="~assets/case/08/img35.jpg")
      .line1 先生从事金融行业，Siney则从事外企咨询业。两人工作都很忙，平时还要在家办公，所以次卧被用作了工作室。
      img.cont-img(src="~assets/case/08/img36.jpg")
      .line1 次卧也是单面刷色，淡粉墙面，配上同色系的窗帘，气质温柔，让人自然冷静下来，很适合工作时的情绪。
      img.cont-img(src="~assets/case/08/img37.jpg")
      .line1 卫生间的处理考虑得很细致，盥洗室跟卫生间隔开。可单独使用，还能借到客厅的光线，在这里化妆方便又自然。
      img.cont-img(src="~assets/case/08/img38.jpg")
      .line1 卫生间干湿分离，厕所和淋浴间能同时使用、互不干扰，符合年轻人快速的生活节奏。
      img.cont-img(src="~assets/case/08/img39.jpg")
      .line1 在家做饭的机会不多，厨房被收拾得整齐干净。墙面全贴瓷砖，非常好清理。
      img.cont-img(src="~assets/case/08/img40.jpg")
      .line1 冰箱上的趣味便签板，不经意间又透露了小年轻的生活趣意。
      img.cont-img(src="~assets/case/08/img41.jpg")
      .cont-title1  Q&A
      .line2 <span>Q：新家的装修审美很不错，有请设计师吗？</span>Siney：我们没有请设计师，搭配都是自己定的。老公对布局有过研究，对灯光的要求也很严格，比如主卧的射灯，光束打在床头必须一定要对称。
      .line2 <span>Q：对软装搭配有什么心得，挑选家具时在意哪些方面呢？</span>Siney：选家具时，我们比较看重样式和性价比。在大众点评上看到懂窝，就过来逛了，当时就觉得家具很好看。就来回逛了几次，挑选了好多款心仪的家具和小件。
    img.scroll-top-btn(v-show="scrollTop", @click="backtop", src="~assets/goTop.png")
</template>

<script>
export default {
  data() {
    return {
      scrollTop: false
    }
  },
  mounted () {
    window.addEventListener("scroll", this.showbtn, true);
  },
  methods: {
    // 显示回到顶部按钮
    showbtn() {
      let that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
    },
    /**
     * 回到顶部功能实现过程：
     * 1. 获取页面当前距离顶部的滚动距离（虽然IE不常用了，但还是需要考虑一下兼容性的）
     * 2. 计算出每次向上移动的距离，用负的滚动距离除以5，因为滚动的距离是一个正数，想向上移动就是做一个减法
     * 3. 用当前距离加上计算出的距离，然后赋值给当前距离，就可以达到向上移动的效果
     * 4. 最后记得在移动到顶部时，清除定时器
     */
    backtop() {
      var timer = setInterval(function() {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    }
  }
};
</script>

<style lang="sass" scoped>
@import 'config'
.d-case
  width: 100%
  position: relative
  padding-top: 0.1px
  .top-img
    width: 100%
    position: absolute
    z-index: -1
  .content
    margin: r(869) auto 0
    width: r(1020)
    // height: r(300)
    background: #ffffff
    padding-top: 0.1px
    padding-bottom: r(350)
    .case-num
      margin: r(43) auto
      width: r(844)
      font-family: PingFangSC-Regular
      font-size: r(20)
      color: #717273
      letter-spacing: 0
    .case-title
      margin: r(18) auto r(50)
      width: r(844)
      font-family: PingFangSC-Medium
      font-size: r(40)
      color: #070809
      line-height: r(60)
    .line1
      margin: r(30) auto
      width: r(844)
      font-family: PingFangSC-Medium
      font-size: r(20)
      color: #585858
      line-height: r(34)
      span
        display: block
        text-align: center
    .cont-img
      margin: r(60) auto 0
      width: r(932)
      display: block
    .cont-title
      margin-top: r(64)
      font-weight: bolder
      font-family: PingFangSC-Medium
      font-size: r(20)
      color: #070809
      text-align: center
    .cont-title1
      margin-top: r(110)
      font-family: PingFangSC-Medium
      font-size: r(20)
      color: #070809
      text-align: center
    .line2
      margin: r(31) auto 0
      width: r(844)
      font-family: PingFangSC-Medium
      font-size: r(20)
      color: #070809
      line-height: r(34)
      span
        display: block
        color: #000000
  .scroll-top-btn
    position: fixed
    z-index: 100
    bottom: r(100)
    right: r(100)
    width: r(80)
</style>



// WEBPACK FOOTER //
// case8.vue?6407258e